import tocbot from "tocbot";

// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", () => {
  // initialize tocbot.js
  function setupTocbot() {
    // Initialize tocbot.js
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: ".agenda-sidemenu",
      // Where to grab the headings to build the table of contents.
      contentSelector: ".js-toc-content",
      // Which headings to grab inside of the contentSelector element.
      headingSelector: "h2, h3, h4",
      // For headings inside relative or absolute positioned containers within content.
      ignoreSelector: ".js-toc-ignore h2, .js-toc-ignore h3, .js-toc-ignore h4",
      hasInnerContainers: true,
      orderedList: false,
    });
  }

  //add accessibility attributes to toc list and link items
  function setupAccessibilityAttributes() {
    // add accessibility attributes to main toc-list element
    const mainToc = document?.querySelector(".agenda-sidemenu > ul.toc-list");
    if (mainToc) {
      mainToc?.setAttribute("role", "navigation");
      mainToc?.setAttribute("aria-label", "Sivun sisällysluettelo");
    }

    // add accessibility attributes to main toc-list element
    const tocLinks = document?.querySelectorAll("a.toc-link");
    if (tocLinks) {
      tocLinks?.forEach((li) => {
        li?.setAttribute("aria-current", "page");
        li?.setAttribute("role", "menuitem");
        li?.setAttribute("tabindex", "0");
      });
    }
  }

  // Add expand buttons to TOC items with nested lists
  function setupExpandButtonsToTocLinks() {
    // Find all li.toc-list-item that contain ul.toc-list
    const tocListItems = document.querySelectorAll("li.toc-list-item");

    tocListItems.forEach((li) => {
      const nestedList = li.querySelector("ul.toc-list");

      if (nestedList) {
        // Create the expand button
        const expandButton = document?.createElement("button");
        if (!expandButton) {
          return;
        }
        expandButton.innerHTML = `
          <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24">
            <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
          </svg>
        `;
        expandButton?.setAttribute("tabindex", "0");
        expandButton?.setAttribute("aria-label", "Avaa osio");
        expandButton?.setAttribute("aria-expanded", "false");
        expandButton.className = "toc-expand-button";

        // Insert the button at the beginning of the list item
        li?.insertBefore(expandButton, li?.lastChild);

        // Add click and keyboard events
        expandButton?.addEventListener("click", toggleExpand);
        expandButton?.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e?.preventDefault();
            toggleExpand?.call(this);
          }
        });
      }
    });

    function toggleExpand(this: any) {
      const button = this;
      const tocList = button?.parentElement?.querySelector("ul.toc-list");

      const isExpanded = button?.getAttribute("aria-expanded") === "true";
      button?.setAttribute("aria-expanded", !isExpanded);

      if (isExpanded) {
        button?.setAttribute("aria-label", "Avaa osio");
      } else {
        button?.setAttribute("aria-label", "Sulje osio");
      }

      if (tocList) {
        tocList?.classList?.toggle("is-collapsed");
      }
    }
  }

  // Add class manipulation observers to .toc-list items that
  // we can simulate expandbutton work like somebody clicked it.
  function setupTocListObservers() {
    const tocLists = document?.querySelectorAll("ul.toc-list");

    tocLists?.forEach((list) => {
      // Create observer instance
      const observer = new MutationObserver(function (mutations) {
        mutations?.forEach(function (mutation) {
          if (
            mutation?.type !== "attributes" ||
            mutation?.attributeName !== "class"
          ) {
            return;
          }

          const expandBtn =
            list?.parentElement?.querySelector(".toc-expand-button");
          if (!expandBtn) {
            return;
          }

          const isCollapsed = list?.classList?.contains("is-collapsed");
          if (!isCollapsed) {
            // This runs when is-collapsed is removed
            expandBtn.setAttribute("aria-expanded", "true");
            expandBtn.setAttribute("aria-label", "Sulje osio");
          } else {
            // This runs when is-collapsed is added
            expandBtn.setAttribute("aria-expanded", "false");
            expandBtn.setAttribute("aria-label", "Avaa osio");
          }
        });
      });

      // Start observing
      observer.observe(list, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  // Add class manipulation observers to .toc-link items that
  // we can simulate expandbutton work like somebody clicked it.
  function setupTocLinkObservers() {
    const tocLinks = document?.querySelectorAll("a.toc-link");
    tocLinks?.forEach((link) => {
      // Create observer instance
      const observer = new MutationObserver(function (mutations) {
        mutations?.forEach(function (mutation) {
          if (
            mutation?.type !== "attributes" ||
            mutation?.attributeName !== "class"
          ) {
            return;
          }

          const isActive = link?.classList?.contains("is-active-link");

          if (!isActive) {
            return;
          }

          const expandBtn =
            link?.parentElement?.querySelector(".toc-expand-button");
          const tocList = link?.parentElement?.querySelector(".toc-list");
          if (expandBtn) {
            expandBtn?.setAttribute("aria-expanded", "true");
          }

          if (tocList) {
            tocList?.classList?.remove("is-collapsed");
          }
          scrollToActiveItem(mutation?.target);
        });
      });

      // Start observing
      observer.observe(link, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  //run functions
  if (!tocbot) {
    return;
  }

  function scrollToActiveItem(activeItem) {
    const menuContainer = document?.querySelector(".agenda-sidemenu-wrapper"); // Your menu container

    if (!menuContainer || !activeItem) {
      return;
    }

    const offset = 16; // Adjust this value for spacing
    const itemPosition = activeItem.offsetTop;
    menuContainer.scrollTo({
      top: itemPosition - offset,
      behavior: "smooth",
    });
  }
  setupTocbot();
  setupAccessibilityAttributes();
  setupExpandButtonsToTocLinks();
  setupTocListObservers();
  setupTocLinkObservers();
});
